import { uniq } from "lodash"
import {
  TOGGLE_SHOOT_DIALOG,
  SET_SHOOTS,
  SET_SHOOT_DIALOG_CREW,
  UPDATE_SHOOT,
  UPDATE_SHOOTS_ARRAY,
  SET_SHOOTS_LENGTH,
  SORT_SHOOTS,
  CLEAR_SHOOTS,
  SET_EDIT_SHOOT,
  TOGGLE_EDIT_SHOOT_DIALOG,
  TOGGLE_CONFIRM_DUPLICATE_DIALOG,
  TOGGLE_CONFIRM_SAVE_SHOOT_DIALOG,
  TOGGLE_CHANGE_REPRESENTATIVE_DIALOG,
  TOGGLE_ROLE_DIALOG,
  SET_ROLE_FOR_CREW,
  SET_ACTIVE_ROLE,
  SET_TOTAL_NUMBERS,
  DELETE_SHOOT_ROLE,
  RECALL_SHOOT,
  UPDATE_SHOOT_ROLE,
  SET_CURRENT_SHOOT,
  NOTIFY_GET_SHOOT_BY_ID,
  NOTIFY_GET_SHOOTS,
  SET_CLIENT_COMPANY_SHOOTS
} from "../actions/shoots"

const defaultState = {
  showDialog: false,
  roleDialog: false,
  dialogData: {},
  shoots: [],
  dialogCrew: null,
  dialogShootId: null,
  shootsLength: null,
  editShootDialogOpen: false,
  editShoot: {},
  changeRepresentativeDialog: false,
  confirmDuplicateShootDialogueOpen: false,
  confirmSaveShootDialogueOpen: false,
  roleSelected: null,
  activeShootRole: null,
  totals: {},
  recall: false,
  currentShoot: {},
  recallGetShootById: false,
  recallGetShoots: false,
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case CLEAR_SHOOTS:
      return {
        ...state,
        shoots: [],
      }
    case RECALL_SHOOT:
      return {
        ...state,
        recall: action.payload,
      }

    case SET_CURRENT_SHOOT:
      return {
        ...state,
        currentShoot: action.payload,
      }

    case NOTIFY_GET_SHOOT_BY_ID:
      return {
        ...state,
        recallGetShootById: action.payload,
      }


    case NOTIFY_GET_SHOOTS:
      return {
        ...state,
        recallGetShoots: action.payload,
      }



    case SET_EDIT_SHOOT:
      return {
        ...state,
        editShoot: action.payload,
      }


    case SET_SHOOTS_LENGTH:
      return {
        ...state,
        shootsLength: action.payload,
      }
    case SORT_SHOOTS:
      return {
        ...state,
        shoots: [...action.payload],
      }
    case SET_SHOOT_DIALOG_CREW:
      return { ...state, dialogCrew: action.payload }
    case SET_ROLE_FOR_CREW:
      return { ...state, roleSelected: action.payload }
    case TOGGLE_SHOOT_DIALOG:
      return {
        ...state,
        showDialog: action.payload.open,
        dialogShootId: action.payload.id,
        dialogData: action.payload.data,
      }
    case TOGGLE_ROLE_DIALOG:
      return {
        ...state,
        roleDialog: action.payload.open,
        dialogShootId: action.payload.id,
      }
    case TOGGLE_EDIT_SHOOT_DIALOG:
      return {
        ...state,
        editShootDialogOpen: action.payload,
      }
    case TOGGLE_CHANGE_REPRESENTATIVE_DIALOG:
      return {
        ...state,
        changeRepresentativeDialog: action.payload,
      }

    case TOGGLE_CONFIRM_SAVE_SHOOT_DIALOG:
      return {
        ...state,
        confirmSaveShootDialogueOpen: action.payload,
      }
    case TOGGLE_CONFIRM_DUPLICATE_DIALOG:
      return {
        ...state,
        confirmDuplicateShootDialogueOpen: action.payload,
      }
    case SET_SHOOTS:
      return {
        ...state,
        shoots: [...state.shoots, ...action.payload],
      }
    case SET_CLIENT_COMPANY_SHOOTS:
      return {
        ...state,
        clientShoots: [...action.payload],
      }
    case SET_TOTAL_NUMBERS:
      return {
        ...state,
        totals: action.payload,
      }
    case UPDATE_SHOOTS_ARRAY:
      if (state.shoots.find(x => x.id === action.payload.id)) {
        return {
          ...state,
          shoots: uniq([
            ...state.shoots.filter(x => x.id !== action.payload.id),
            action.payload,
          ]),
        }
      } else {
        return state
      }
    case UPDATE_SHOOT:
      return {
        ...state,
        shoots: state.shoots.map(shoot => {
          if (shoot.id === action.shootId) {
            shoot = {
              ...shoot,
              ...action.data[0],
            }
          }
          return shoot
        }),
      }
    case DELETE_SHOOT_ROLE:
      return {
        ...state,
        shoots: [
          ...state.shoots.map(shoot => {
            if (Number(shoot.id) === Number(action.shootId)) {
              shoot = {
                ...shoot,
                roles: shoot.roles.filter(
                  role => role.user_id !== action.userId
                ),
              }
            }
            return shoot
          }),
        ],
      }
    case UPDATE_SHOOT_ROLE:
      return {
        ...state,
        shoots: [
          ...state.shoots.map(shoot => {
            if (Number(shoot.id) === Number(action.shootId)) {
              shoot = {
                ...shoot,
                roles: shoot.roles.map(role => {
                  if (role.user_id !== action.userId) {
                    return role
                  } else {
                    return { ...role, ...action.data }
                  }
                }),
              }
            }
            return shoot
          }),
        ],
      }
    case SET_ACTIVE_ROLE:
      return {
        ...state,
        activeShootRole: action.shootRole,
      }
    default:
      return state
  }
}
